import { StorefrontHeader } from '../features/storefront/StorefrontHeader';
import {
  PUBLIC_POLICY_DOCUMENTS,
  isPolicySlug,
  type PolicyInline,
} from '../content/publicPolicies';
import { StoreFooter } from './StorefrontPage';

function renderInline(content: PolicyInline[]) {
  return content.map((part, index) => {
    const key = `${part.type}-${index}`;
    if (part.type === 'strong') return <strong key={key}>{part.value}</strong>;
    if (part.type === 'code') return <code key={key}>{part.value}</code>;
    if (part.type === 'link')
      return (
        <a key={key} href={part.href}>
          {part.label}
        </a>
      );
    if (part.type === 'break') return <br key={key} />;
    return <span key={key}>{part.value}</span>;
  });
}

export function PolicyPage({
  page,
  navigate,
}: {
  page: string;
  cart?: unknown;
  navigate: (path: string) => void;
}) {
  const policy = PUBLIC_POLICY_DOCUMENTS[isPolicySlug(page) ? page : 'terms'];
  return (
    <div className="store-shell">
      <StorefrontHeader navigate={navigate} />
      <main className="policy-page">
        <p className="store-kicker">Wild Trails Kids</p>
        <h1>{policy.title}</h1>
        <div className="policy-content">
          {policy.blocks.map((block, blockIndex) => {
            const key = `${block.type}-${blockIndex}`;
            if (block.type === 'heading') return <h2 key={key}>{renderInline(block.content)}</h2>;
            if (block.type === 'table') {
              return (
                <div className="policy-table-scroll" key={key} tabIndex={0}>
                  <table>
                    <thead>
                      <tr>
                        {block.headers.map((cell, index) => (
                          <th key={index} scope="col">
                            {renderInline(cell)}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {block.rows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {row.map((cell, cellIndex) =>
                            cellIndex === 0 ? (
                              <th key={cellIndex} scope="row">
                                {renderInline(cell)}
                              </th>
                            ) : (
                              <td key={cellIndex}>{renderInline(cell)}</td>
                            ),
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            }
            return (
              <p className={blockIndex === 0 ? 'policy-lead' : undefined} key={key}>
                {renderInline(block.content)}
              </p>
            );
          })}
        </div>
      </main>
      <StoreFooter navigate={navigate} />
    </div>
  );
}
